module.exports = __webpack_public_path__ + "img/mas_buscados_4.5ef561bd.png";